import 'regenerator-runtime/runtime';
import Vue from 'vue';
import Notifications from 'vue-notification';
import App from '~/App.vue';
import { humanReadableField } from '~/filters/humanReadableField';
import router from '~/router';
import httpService from '~/services/http.service';
import { ConfigModule } from '~/store/modules/config';
import { OperatorModule } from '~/store/modules/operator';
import '~common-plugins/cookies';
import vuetify from '~common-plugins/vuetify';
import store from '~common-store';
import { AppModule } from '~common-store/modules/app';

import UserRightsMixin from '~/mixins/UserRightsMixin';
import { DevicesModule } from '~/store/modules/devices';
import { LayoutModule, LayoutModule as SupportLayoutModule } from '~/store/modules/layout';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import MainPlugin from '~common-plugins/mainPlugin';

// popup imports specific to support
Vue.component('UserLogsPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/User/Logs/index.vue'));
Vue.component('UserOrdersPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/User/Orders.vue'));
Vue.component('MarketingConsentsHistoryPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/User/MarketingConsentsHistory.vue'));
Vue.component('OperationDumpPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/Dump.vue'));
Vue.component('OperationDumpLogsPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/DumpLogs.vue'));
Vue.component('OperationModalWeatherExtractPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/ModalWeatherExtract.vue'));
Vue.component('OperationLogsPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/Logs.vue'));
Vue.component('OperationModelDumpPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/ModelDump.vue'));
Vue.component('OperationDiagnosisPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/Diagnosis.vue'));
Vue.component('OperationStatsDumpPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/StatsDump.vue'));
Vue.component('OperationLocalResourcesPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/LocalResources.vue'));
Vue.component('OperationTimelinePopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/Timeline.vue'));
Vue.component('OperationAssociateUserPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/AssociateUser.vue'));
Vue.component('OperationImportDataPopup', () => import(/* webpackChunkName: "components-bundle" */ '~/components/Popups/Operations/ImportData/index.vue'));
Vue.component('CopyElementWrapper', () => import(/* webpackChunkName: "components-bundle" */ '~/components/CopyElementWrapper.vue'));
Vue.component('CopyRouteWrapper', () => import(/* webpackChunkName: "components-bundle" */ '~/components/CopyRouteWrapper.vue'));

Vue.use(MainPlugin);
Vue.use(Notifications);

async function initApp() {
    httpService.defaults.baseURL = ConfigModule.apiAdminUrl;
    LayoutModule.setDarkMode(window.localStorage.getItem('darkMode') === 'true');

    SupportLayoutModule.setRoomModeActive(window.localStorage.getItem('isRoomModeActive') === 'true');
    await OperatorModule.getAdminRights();

    if (OperatorModule.adminRights.TopologyNetatmo && ConfigModule.environmentPrefix === 'netatmo') {
        try {
            await DevicesModule.getMacRangeCsv();
        } catch (e) {
            console.error(e);
        }
    }
    router.beforeEach((to: any, from: any, next: any) => {
        if (to.matched.some((record: any) => record.name === 'redirect')) {
            next();
        } else {
            if (ConfigModule.accessToken) {
                next();
            } else {
                next({
                    name: 'redirect',
                    query: {
                        url: `${ConfigModule.checkLoginUrl}?next_url=${encodeURIComponent(ConfigModule.baseUrl + to.path)}`,
                    },
                });
            }
        }
    });
    router.onError((error) => {
        if (/loading chunk \d* failed./i.test(error.message)) {
            window.location.reload();
        }
    });

    new Vue({
        router,
        store,
        vuetify,
        render: (h: any) => h(App),
    }).$mount('#app');
}
initApp();

Vue.filter('humanReadableField', humanReadableField);
Vue.mixin(UserRightsMixin);
Vue.mixin(DarkThemeInfoMixin);

AppModule.setAdminApp('support');
